import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { upperFirst } from 'lodash';

const Authorization = allowedRoles => WrappedComponent => {
  @inject('customerCaseStore')
  @observer
  class WithAuthorization extends React.Component {
    constructor(props) {
      super(props);
    }

    render() {
      var userRole = this.props.customerCaseStore.currentUser ?
        this.props.customerCaseStore.currentUser.templateRightsLevel :
        null;

      if (o.is(allowedRoles, userRole)) {
        return <WrappedComponent {...this.props} />;
      }

      return null;
    }
  };

  return WithAuthorization;
};

const levels = {
    admin: ['admin'],
    manager: ['manager', 'admin'],
    user: ['user', 'manager', 'admin']
}

let o = {
    levels,
    all: () => Object.keys(levels),
    is: (targetGroup, userRightsLevel) =>
      (Array.isArray(targetGroup) ? targetGroup : levels[targetGroup]).includes(userRightsLevel)
}

Object.keys(levels).forEach(level => {
    // adds function is{Level}(userLevelGroup)
    let fn = `is${upperFirst(level)}`;
    o[fn] = userLevelGroup => o.is(level, userLevelGroup);

    // adds function {Level}Component
    fn = `${upperFirst(level)}Component`;
    o[fn] = Authorization(level);
});

export default o;



// WEBPACK FOOTER //
// ./src/permissions.js